import styled from "styled-components"

export default function AchievementInfo({ nickname, minAuth, maxAuth, currAuth }) {
  let achievementText = `달릴 준비 되셨나요? 준비이~ 땅!💥`

  if (currAuth >= maxAuth) {
    achievementText = "끝까지 달린 당신은 불꽃 열정러🔥"
  } else if (currAuth > minAuth && currAuth < maxAuth) {
    achievementText = "우리 끝까지 완주해봐요!"
  } else if (currAuth === minAuth) {
    achievementText = "축하해요! 환급조건을 달성했어요 🎉"
  } else if (currAuth < minAuth && currAuth > 5) {
    achievementText = `${minAuth - currAuth}번만 더하면 환급받을 수 있어요!`
  } else if (currAuth < minAuth && currAuth > 0) {
    achievementText = `잘 달리고 있어요! 페이스를 유지해봐요🔥`
  }

  return (
    <Block>
      <Nickname>{`${nickname}님,`}</Nickname>
      <AchievementGoalDesc>{achievementText}</AchievementGoalDesc>
    </Block>
  )
}

const Block = styled.div`
  display: flex;
  flex-direction: column;
`

const Nickname = styled.span`
  font-family: "Noto Sans KR";
  font-size: calc(100vw * (20 / 375));
  font-weight: 700;
  line-height: calc(100vw * (32 / 375));
`

const AchievementGoalDesc = styled.p`
  font-family: "Noto Sans KR";
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  line-height: calc(100vw * (25 / 375));
`
